import { CrystalTripDTO, ResponseType } from 'business/models/Models';
import CrystalService from 'business/services/CrystalService';
import SynchrotronTripService from 'business/services/SynchrotronTripService';
import EAlertType from 'enums/EAlertType';
import ESnackBarPosition from 'enums/ESnackBarPosition';
import { useRMDispatch } from 'redux/hooks';
import {
  setallSynchTrips,
  setCrystalTrips,
  setHarvestingContentView,
  setSelectedTripId,
} from 'redux/reducers/synchrotronTripReducer';
import { showAlertSnackBar } from 'utils/Global';
import { EHarvestingView } from '../constants';
import { useCrystalStates, useFetchCrystalTrip } from '../Crystal/hooks';
import { useSelectedTripId } from 'redux/hooks/synchrotron';
import { useCurrentTripCheckedCrystals } from 'redux/hooks/crystal';
import { useCallback, useMemo } from 'react';

export const useFetchAllSynchTrips = () => {
  const dispatch = useRMDispatch();
  const synchService = useMemo(() => new SynchrotronTripService(), []);

  return useCallback(async () => {
    const trips = await synchService.getOpenSynchTrips();
    dispatch(setallSynchTrips(trips));
  }, [dispatch, synchService]);
};

export const useApplyCrystalsToTrip = (tripId: number, setHandleOnTabBackPress) => {
  const { crystalsTrips, allSynchTrips } = useCrystalStates();
  const currentTripcheckedCrystals = useCurrentTripCheckedCrystals();
  const selectedTripId = useSelectedTripId();
  const dispatch = useRMDispatch();
  const { fetchCrystalTrips } = useFetchCrystalTrip(false);
  const createCrystalClientData = () => {
    const crystalTripsToSave = currentTripcheckedCrystals.map(
      (val) =>
        ({
          id: crystalsTrips.find((x) => x.crystalId === val)?.id,
          crystalId: val,
          synchrotronTripId: tripId,
          puckPinId: null,
          synchrotronTripName: allSynchTrips.filter((x) => x.id === tripId)[0]
            ?.synchTripName,
          dataCollectionDate: allSynchTrips.filter((x) => x.id === tripId)[0]
            ?.dataCollectionDate,
        } as CrystalTripDTO),
    );
    return crystalTripsToSave;
  };

  const unAssignAlreadyAssignedCrystals = () => {
    let updatedCrystalTrips = [...crystalsTrips];
    if (crystalsTrips.some((x) => currentTripcheckedCrystals.includes(x.crystalId))) {
      updatedCrystalTrips = updatedCrystalTrips.filter(
        (x) => !currentTripcheckedCrystals.includes(x.crystalId),
      );
    }
    return updatedCrystalTrips;
  };

  const addCrystal = async () => {
    const crystalTripsToSave = createCrystalClientData() as CrystalTripDTO[];
    const crystalService = new CrystalService();
    const response = await crystalService.AssignCrystalsToTrip(crystalTripsToSave);
    if (response.responseType === ResponseType.Error) {
      showAlertSnackBar(EAlertType.ERROR, ESnackBarPosition.TOP, response.message);
      if (response.value) {
        showAlertSnackBar(EAlertType.ERROR, ESnackBarPosition.TOP, response.message);
        fetchCrystalTrips();
        return;
      }
    } else {
      const crystalTripsAdded = response.value.crystalTrips as CrystalTripDTO[];
      crystalTripsAdded.map((trip) => {
        trip.synchrotronTripName = allSynchTrips.filter(
          (x) => x.id === trip.synchrotronTripId,
        )[0]?.synchTripName;
        trip.dataCollectionDate = allSynchTrips.filter(
          (x) => x.id === trip.synchrotronTripId,
        )[0]?.dataCollectionDate;
      });
      const updatedCrystalTrips = unAssignAlreadyAssignedCrystals();
      const newCrystalTrips = crystalTripsAdded.concat(...updatedCrystalTrips);
      dispatch(setCrystalTrips(newCrystalTrips));
      showAlertSnackBar(
        EAlertType.SUCCESS,
        ESnackBarPosition.TOP,
        `${selectedTripId ? 'Move Crystal Cart Success' : response.message}`,
      );
      dispatch(setSelectedTripId(tripId));
      if (response.value.refetchCrystalDetails === true) {
        fetchCrystalTrips();
      }
    }
  };

  return async () => {
    await addCrystal();
    dispatch(setHarvestingContentView(EHarvestingView.HARVESTING));
    setHandleOnTabBackPress(null);
  };
};
